import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-client-admin-my-company',
  templateUrl: './client-admin-my-company.component.html',
  styleUrls: ['./client-admin-my-company.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClientAdminMyCompanyComponent {}
